module.exports = __webpack_public_path__ + "img/SketchPng321eaa360b73d66285bcc98f3ee5b8a677069cbd510e7d9902faf214fb05aaa6.29c2a328.png";